






















import { defineComponent, computed } from '~/utils/nuxt3-migration'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { useUserAgent } from '~/compositions/user-agent'
import { useDep } from '~/compositions/dependency-container'
import InstallmentsService from '~/services/classified/finance/InstallmentsService'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { AccessToggleName } from '~/models/user/access-toggles'

export default defineComponent({
  setup() {
    const {
      dispatch: classifiedViewDispatch,
      state: classifiedViewState,
      getters: classifiedViewGetters
    } = useNamespacedStore<ClassifiedViewState>(CLASSIFIED_VIEW_NS)

    const { isPc } = useUserAgent()

    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const userHasAccessTo = userGetters('userHasAccessTo')

    const installmentsService = useDep(InstallmentsService)

    const showFinance = computed(() => classifiedViewGetters('showFinance'))

    const showOnlineFinancing = computed(() =>
      classifiedViewGetters('showOnlineFinancing')
    )

    const isInsuranceAvailable = computed(() =>
      classifiedViewGetters('isInsuranceAvailable')
    )

    const isVehicleClassified = computed(() =>
      classifiedViewGetters('isVehicleClassified')
    )

    const isPlotClassified = computed(() =>
      classifiedViewGetters('isPlotClassified')
    )

    const monthlyInstallmentAmount = computed(() => {
      return classifiedViewGetters(
        'getMonthlyInstallmentAmount',
        installmentsService
      )
    })
    const showFinanceButton = computed(() => {
      if (
        isPc.value &&
        (classifiedViewState.leasing.option ||
          (classifiedViewState.classified.finance &&
            monthlyInstallmentAmount.value))
      ) {
        return false
      }

      if (
        isPlotClassified.value &&
        !userHasAccessTo(AccessToggleName.LOANS_TESTER)
      ) {
        return false // delete this after piraeus confirms
      }

      return showFinance.value || showOnlineFinancing.value
    })

    const scrollToFinance = () => {
      classifiedViewDispatch('scrollToFinance')
    }
    const scrollToInsurance = () => {
      classifiedViewDispatch('scrollToInsurance')
    }

    return {
      showFinanceButton,
      scrollToFinance,
      isInsuranceAvailable,
      scrollToInsurance,
      isVehicleClassified
    }
  }
})
